import actions from './module-supplier-no-down-actions';
import getters from './module-supplier-no-down-getters';
import mutations from './module-supplier-no-down-mutation';
import state from './module-supplier-no-down-state.js';

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
